import { type FieldValues, type UseControllerProps, useFormContext } from 'react-hook-form';

import { RimmSubEntitySelect, type TRimmSubEntitySelectProps } from '../../../rimm/components/RimmSubEntitySelect';
import { type LicenseFieldProps } from './LicenseFieldController';

import { useLicenseController } from '../../hooks/useLicenseController';

import { type RimmEntityType, type RimmSubEntityType } from '../../../rimm/data/rimmEntityEnums';

export const LicenseRimmSubEntitySelectField = ({
  name,
  defaultValue,
  configName,
  featureFlag,
  viewMode,
  rules,
  shouldUnregister,
  control,
  disabled,
  ...rest
}: TRimmSubEntitySelectProps<RimmSubEntityType, RimmEntityType> &
  LicenseFieldProps &
  UseControllerProps<FieldValues, any>) => {
  const { control: contextControl } = useFormContext();

  const {
    field: { value, onChange, onBlur, ...fieldRest },
    computedProps,
    config,
  } = useLicenseController({
    name,
    configName,
    featureFlag,
    control: control ?? contextControl,
    defaultValue: defaultValue ?? null,
    rules,
    shouldUnregister,
    viewMode,
    disabled,
  });

  const handleChange: typeof rest.onChange = (...args) => {
    const option = args[0];

    const newValue = option
      ? {
          label: option.label,
          value: option.value,
          ...(option.tag && {
            tag: option.tag,
          }),
        }
      : null;

    onChange(newValue);

    if ('onChange' in rest && typeof rest.onChange === 'function') {
      rest.onChange(...args);
    }
  };

  const handleBlur: typeof rest.onBlur = (...args) => {
    onBlur();

    if ('onBlur' in rest && typeof rest.onBlur === 'function') {
      rest.onBlur(...args);
    }
  };

  if (config.isHidden) {
    return <></>;
  }

  return (
    <RimmSubEntitySelect {...fieldRest} {...computedProps} {...rest} onChange={handleChange} onBlur={handleBlur} />
  );
};
